import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const f5DistributedCloudServices = defineConnector({
  identifier: "f5DistributedCloudServices",
  name: "F5 Distributed Cloud Services",
  tagLine: "Multi-cloud networking and security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) => domainToRegex(domain),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiToken,
        scheme: "APIToken",
      },
    ]),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In the F5 Distributed Cloud Console, open **Administration → Personal Management → Credentials**, create an API token, and copy it.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          helperText: "Paste the API token from **Credentials**.",
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
    {
      title: "Enter your domain",
      items: [
        {
          kind: "hostname",
          label: "Domain",
          placeholder: "your-tenant.console.ves.volterra.io",
          required: true,
          helperText: "Enter the tenant domain from your console URL.",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/web/namespaces`,
  },
});
